// This will eventually be pulled from the server
var resource = {}
async function fetchStaticResources(){
    try {
        const response = await fetch("/static/i18n/i18n.json"); // Fetch the file
        if (!response.ok) {
            // throw new Error(`HTTP error status: ${response.status}`);
        } else {

            const data = await response.text(); 
            resource = JSON.parse(data || "{}");
        }
    } catch (error) {
        console.error('Error fetching JSON file:', error);
    }
}

async function loadResourceFile() {
    await fetchStaticResources()
}


loadResourceFile();


function translate(text, lang) {
    var returnText = text;
    var searchText = text.toLowerCase().split(" ").join("")
    if (!lang) {
        lang = "en"
        if (window.App && window.App.userContext){
            if (window.App.userContext.extendedAttributes && window.App.userContext.extendedAttributes.preferredLanguage) {
                lang = window.App.userContext.extendedAttributes.preferredLanguage
            }
        }
    }

    if (resource[lang]){
        const r = resource[lang]
        if (r[searchText]) {
            returnText = resource[lang][searchText]
        }
    } 

    return returnText;
}

export default translate